import HotelList from "../components/HotelList";
import { Helmet } from "react-helmet-async";

export default function Hotels() {
    return (
        <>
            <Helmet>
                <title>Hotels in Dubai | Beach Hotels Dubai</title>

                <meta
                    name="description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Beach Hotels Dubai."
                />

                <link
                    rel="canonical"
                    href="https://dubaibudgetivehotels.com/hotels"
                />

                {/* Open Graph */}
                <meta
                    property="og:title"
                    content="Hotels in Dubai | Beach Hotels Dubai"
                />

                <meta
                    property="og:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Beach Hotels Dubai."
                />

                <meta
                    property="og:url"
                    content="https://dubaibudgetivehotels.com/hotels"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                {/* Twitter */}
                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="Hotels in Dubai | Beach Hotels Dubai"
                />

                <meta
                    name="twitter:description"
                    content="Browse cheap hotels, budget stays, apartments, and affordable accommodations in Dubai with Beach Hotels Dubai."
                />

                <meta
                    name="robots"
                    content="index, follow"
                />
            </Helmet>

            <main className="hotels-page min-h-screen bg-[#F3F8FF] pb-16">
                <div className="mx-auto w-full">
                    {/* <div className="mx-auto w-full max-w-[1440px] px-5 sm:px-8 lg:px-12 xl:px-16"> */}
                    <div className="hotels-content">
                        <HotelList
                            showSidebar={true}
                            showBanner={true}
                            showHeading={false}
                        />
                    </div>
                </div>
            </main>
        </>
    );
}